export { default } from './HelpCenter.vue';